import axios from "axios";
import store from "../../../../../stores/application/index.js.erb";

const prtfPortfolioPath = `/portfolio/api/prtf_portfolios`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

function setFormData(photo) {
    const formatData = new FormData();

    for  (let key in photo) {
        formatData.append(`prtf_portfolio[${key}]`, photo[key]);
    }

    return formatData
}

const PrtfPortfolioApiService = {

    async index() {
        get_token();
        try {
            return await axios.get(`${prtfPortfolioPath}.json`);
        } catch (e) {
            console.log("Error");
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, попробуйте позже!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    async getRatingPortfolios() {
        get_token();
        try {
            return await axios.get(`${prtfPortfolioPath}/get_rating_portfolios.json`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, попробуйте позже!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    async editAvatarPortfolio(payload) {
        get_token();
        const formPayload = setFormData(payload);
        try {
            return await axios.patch(`${prtfPortfolioPath}/edit_avatar_portfolio.json`,
                formPayload,
                {headers: {'Content-Type': 'multipart/form-data'}}
            );
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, попробуйте позже!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

}

export default PrtfPortfolioApiService;